<script setup>
import { stateManager } from '@/stateManager';
import salmiListJson from "@/assets/json/salmi.json";
import salmiListJson_forSearch from "@/assets/json/salmiForSearch.json";
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

onMounted(() => {
    document.addEventListener('click', onDocumentClick);
    
    // ctrl + k per aprire la ricerca
    window.addEventListener('keydown', (e) => {
        const tgt = e.target;
        if(tgt && (tgt.isContentEditable || ['INPUT','TEXTAREA','SELECT'].includes(tgt.tagName)))
            return;

          if ((e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && e.code === 'KeyK') {
            e.preventDefault();
            e.stopPropagation();
            searchInputRef.value?.focus();
        }
    }, { capture: true });

    lunrjs_init(); // init website search
});
onBeforeUnmount(() => { 
    document.removeEventListener('click', onDocumentClick); 
    // document.removeEventListener('onKeyUp', onKeyUp);

})

const salmi = salmiListJson.items;
const salmiForSearch = salmiListJson_forSearch.items;
let idx = null;
let searchBarStatus = {
    isSearchInputActive: false,
    showSearchResults: false,
    defaultDisplayText: 'I risultati della tua ricerca vengono mostrati sotto. Clicca su un risultato per accedere al contenuto completo.',
    displayText: 'I risultati della tua ricerca vengono mostrati sotto. Clicca su un risultato per accedere al contenuto completo.',
    searchResult: undefined,
    resultOfSearch: null
};
const searchInputRef = ref(null);
const searchString = ref('');

function onKeyUp(e) {
    if(e.ctrlKey && e.key.toLowerCase() === 'k') {
        e.preventDefault(); // avoid pre definited behavior
        searchInputRef.value?.focus();
        alert('hello')
        console.log('hi!')
    }
}

function onDocumentClick(e) { 
    let parent = document.querySelector('#searchResults');
    if(e && e.target && parent) {
        // if there is parent the 'rearch result are showing'
        // when isContained is false so HIDE search res.
        let isContained = parent.contains(e.target);
        if(!isContained) {
            searchBarStatus.showSearchResults = false;
            searchBarStatus.displayText = searchBarStatus.defaultDisplayText;
            this.searchString = '';
        }
    }
};  

function setFocusOnSearch() {
    // fix non-focus issue. Pobably needed to wait the CSS update
    setTimeout(x => {
        searchInputRef.value?.focus();
    }, 100);    
};

function setSearchInputState(value) {
    searchBarStatus.isSearchInputActive = value;
    stateManager.isSearchInputActive = value;
}

function hideSearchResults() {
    searchBarStatus.displayText = searchBarStatus.defaultDisplayText;
    searchBarStatus['showSearchResults'] = false;
    searchString.value = '';
}

function isInt(value) {
    return !isNaN(value) && (function(x) { return (x | 0) === x; })(parseInt(value))
}

// define idx <---
function lunrjs_search(searchQuery) {
    // init a simple L. search
    let results = idx.search(searchQuery);

    if(results.length && salmiForSearch) {
        // little work to get the full element (salmo/i) from the small search result item
        let results_full = results.map(function (item) {
            return salmiForSearch.filter(function (value, index, arr) {
                return value.titleWithNumber == item.ref;
            })[0];
        });

        // show results
        searchBarStatus.displayText = 'Ecco i risultati della tua ricerca';
        searchBarStatus.searchResult = results_full;
        searchBarStatus['showSearchResults'] = true;
    }
}

function printSearchResults(mess, quest, items) {
    if(quest && quest == 'itemNotFount') {
    // show 'la ricerca non ha prodotto risultati'
    searchBarStatus.displayText = mess;
    searchBarStatus.searchResult = [];

    } else if(quest && quest == 'GoToSalmoNumber') {
    // show the current salmo in Search Result
    searchBarStatus.displayText = mess;
    searchBarStatus.searchResult = items;
    searchBarStatus['showSearchResults'] = true;
    }
    
    else {
    // nessuno dei prececedenti, quindi:
    // show 'la ricerca non ha prodotto risultati'
    searchBarStatus['showSearchResults'] = true;
    }
};

function customSearch() { 
// and if user search Salmo 10? or n/numero 1? libro 3? or 01 001?
// todo: validate inputs from h@ck3rs!!1!
let _searchString = searchString.value.trim(),
    _isInt = false;

if(!_searchString) { // la searchString è vuota.
    hideSearchResults();
    return;
} 

if(isInt(_searchString)) _isInt = true;
if(_isInt) _searchString = parseInt(_searchString); // set 01 to 1

    
    if(!_isInt && _searchString.trim().length > 1) { 
    //se non è un numero, se la stringa è più lunga di 1 avvio la ricerca con Lunr.js

    lunrjs_search(_searchString);

    } else if (_isInt && _searchString > 0 && _searchString < 151) { 
    // il numero è valido, restituisco il salmo (bug: 01 is working)
    let mess = 'Clicca qui sotto per leggere il salmo numero ' + _searchString;
    let quest = 'GoToSalmoNumber';
    let items = [salmi[_searchString-1]]; 

    printSearchResults(mess, quest, items);
    } else {
    // nessun risultato
    let mess = 'La parola che stai cercando è troppo corta oppure il numero che hai inserito non è valido.';
    let quest = 'itemNotFount';
    printSearchResults(mess, quest);
    }
};

function goToSalmo_and_closeMenu(n) {
    searchBarStatus.showSearchResults = false;
    searchBarStatus.displayText = searchBarStatus.defaultDisplayText;
    searchString.value = '';
    setSearchInputState(false);
    router.push({ name: "salmo", params: { number: n } });
};

function lunrjs_init() {
      /* build the search index in var 'idx' using lunr() func... 3 steps:
          - tell Lunr the reference field (usally a numeric-unique-id)
          - tell L. the list of fields part of search (title, desc, content...)
          - tell L. the dataset.

          ...is possibile to "Prebuilding Lunr.js's search index", see: https://opensource.com/article/21/11/client-side-javascript-search-lunrjs
          ...Lurn non da possibilità di cercare solo una certa quantità di risultati,
             per grosse query potrebbe essere lento e poco funzionale.
      */
      idx = lunr(function() {
        this.ref('titleWithNumber') // usually a number-unique-id
        this.field('titleWithNumber') 
        this.field('title') 
        this.field('content') 

        if(salmiForSearch) {
          salmiForSearch.forEach(function(doc) { // build index from salmi json list
             if(doc.content && typeof(doc.content) != 'string') { // typeof for avoid a js-error
              doc.content = doc.content.join(); // for index the array of string I convert to 1 string (see stackoverflow)
             }
             this.add(doc);       

          }, this);
        }
      }); // if no error we build successfully the index.
}
</script>

<template>
        <div class="navbar-search" :class="[{ active: stateManager.isSearchInputActive }]">
          <div class="search-bar-mobileIcon" alt="clicca per cercare un salmo" @click="setSearchInputState(true); setFocusOnSearch()" :class="{ notActive: stateManager.isSearchInputActive }">
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path fill="currentColor" d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
            </svg>
          </div>

          <div class="search-bar-mobileCloseIcon" alt="clicca per chiudere la ricerca" @click="setSearchInputState(false)" :class="{ active: stateManager.isSearchInputActive, notActive: !stateManager.isSearchInputActive }">
           <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                <path fill="currentColor" d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" />
            </svg>
          </div>

          <div class="search-bar search-bar-mobile" :class="{ active: stateManager.isSearchInputActive }">
            <input id="hideOnMenuOpen_issue" v-model="searchString" ref="searchInputRef" type="text"
               v-on:keyup="customSearch()"
               v-on:enter="customSearch()" 
               placeholder="Ricerca">
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path fill="currentColor" d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
            </svg>
          </div>

          <div class="searchResults" id="searchResults" v-if="searchBarStatus['showSearchResults']">
            <div class="searchInfo">
              <div>
                <span>Risultati</span>
                <span class="subTitle">{{searchBarStatus.displayText}}</span>
              </div>
            </div>
  
            <!-- limito i risultati con slice -->
            <div class="searchResult_Content" v-if="searchBarStatus.searchResult">
              <div class="single" v-for="(item, key) in searchBarStatus.searchResult.slice(0,15)" @click="goToSalmo_and_closeMenu(item.titleWithNumber.split(' ')[1])">
                  <span class="title" v-if="item.titleWithNumber">{{item.titleWithNumber}}</span> &#8226;
                  <span class="rawTitle" v-if="item.title">{{item.title}}</span>
                  <span class="description" v-if="salmi[item.titleWithNumber.split(' ')[1]-1]"><span>1.</span>{{salmi[item.titleWithNumber.split(' ')[1]-1].content[0]}} <span>2.</span>{{salmi[item.titleWithNumber.split(' ')[1]-1].content[1]}}</span>
              </div>
              <!-- link to salmo -->
            </div>
          </div>

        </div>
</template>